import { useQuery } from "react-query";
import { clearStoredAuth } from "../utils";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../config";

type ApiError = Error & { status?: number };

const fetchFiles = async (id: string): Promise<string[]> => {
  const res = await fetch(`${API_URL}/flights/${id}/files`, {
    credentials: "include",
  });

  let body: any = null;
  try {
    body = await res.json();
  } catch (error) {
    body = null;
  }

  if (!res.ok) {
    const errorMessage =
      body?.message ?? `Request failed with status ${res.status}`;
    const error: ApiError = new Error(errorMessage);
    error.status = res.status;
    throw error;
  }

  return body;
};

const useFiles = (id: string) => {
  const navigate = useNavigate();

  return useQuery<string[], ApiError>(["files", id], () => fetchFiles(id), {
    refetchOnWindowFocus: false,
    retry: 1,
    onError: (error) => {
      const status = error.status ?? Number(error.message);
      if (status === 401) {
        clearStoredAuth();
        navigate("/");
      }
    },
  });
};

export default useFiles;
